import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import BuilderInfoHeaderView from './BuilderInfoHeaderView.html';
import './BuilderInfoHeader.scss';
let BuilderInfoHeaderComponent = class BuilderInfoHeaderComponent {
    constructor() {
        this.showNew = false;
        this.lowerCaseHeader = false;
        this.lowerCaseInfo = false;
        this.$onSwitchClicked = ($event) => {
            this.onSwitchClicked({ $event });
        };
    }
    toggleInfo(event) {
        event.stopPropagation();
        this.showInfo = !this.showInfo;
        this.onInfoClicked && this.onInfoClicked();
    }
};
BuilderInfoHeaderComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: BuilderInfoHeaderView,
        bindings: {
            showInfo: '<?',
            showNew: '<?',
            lowerCaseHeader: '<?',
            lowerCaseInfo: '<?',
            header: '@',
            info: '@?',
            tooltip: '@?',
            position: '@?',
            extra: '@?',
            onInfoClicked: '&?',
            onSwitchClicked: '&?',
            switchChecked: '=?',
            url: '@?',
            descriptionUrl: '@?',
            onToggle: '&?',
        },
    }),
    __metadata("design:paramtypes", [])
], BuilderInfoHeaderComponent);
export { BuilderInfoHeaderComponent };
